<template>
  <div class="">
    <div class="row">
      <div class="col-10 offset-1 col-md-6 offset-md-3 text-center mt-4">
        <div class="blaPackagesTitle">
          Próbáld ki az alkalmazást ingyen, vagy legyél PRO a további tartalmak
          eléréséhez
        </div>
        <div class="row align-content-center mt-2 mb-1">
          <div class="col-12 col-md-6">
            <div class="blaPackagesBox blaPackagesBoxWhite">
              <div class="blaPackagesBoxHeader">
                <div class="blaPackagesBoxTitle">
                  Skillers
                  <br />
                  INGYENES
                  <hr />
                </div>
              </div>
              <div class="blaPackagesBoxContent">
                <div class="row">
                  <div class="col-3 text-right">
                    <img
                      :src="require('@/assets/img/check.png')"
                      alt="check_icon"
                      class="blaPackagesImg"
                    />
                  </div>
                  <div class="col-9 text-left blaPackagesBoxContentStrong">
                    Hozzáférés a próbaleckékhez
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-3 text-right">
                    <img
                      :src="require('@/assets/img/lock_purple.png')"
                      alt="lock_icon"
                      class="blaPackagesImg"
                    />
                  </div>
                  <div class="col-9 text-left">
                    Hozzáférés az összes előadás leckéihez
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-3 text-right">
                    <img
                      :src="require('@/assets/img/lock_purple.png')"
                      alt="lock_icon"
                      class="blaPackagesImg"
                    />
                  </div>
                  <div class="col-9 text-left">
                    Hozzáférés a havi témakör leckéihez
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-3 text-right">
                    <img
                      :src="require('@/assets/img/lock_purple.png')"
                      alt="lock_icon"
                      class="blaPackagesImg"
                    />
                  </div>
                  <div class="col-9 text-left">
                    Hozzáférés szókincsépítő leckékhez
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-3 text-right">
                    <img
                      :src="require('@/assets/img/lock_purple.png')"
                      alt="lock_icon"
                      class="blaPackagesImg"
                    />
                  </div>
                  <div class="col-9 text-left">Hozzáférés a kiejtést fejlesztő leckékhez</div>
                </div>
                <div class="row my-5 pt-5 pb-3">
                  <div class="col-12 col-md-6">
                    <img
                      :src="require('@/assets/img/playstore.png')"
                      alt="playstore"
                      class="img-fluid clickable"
                      @click="goToPlaystore"
                    />
                  </div>
                  <div class="col-12 col-md-6 mt-3 mt-md-0">
                    <img
                      :src="require('@/assets/img/appstore.png')"
                      alt="appstore"
                      class="img-fluid clickable"
                      @click="goToAppleStore"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="blaPackagesBox blaPackagesBoxPurple">
              <div class="blaPackagesBoxHeader">
                <div class="blaPackagesBoxTitlePurple">
                  Skillers - PRO
                  <br />
                  <br />
                  <hr />
                </div>
              </div>
              <div class="blaPackagesBoxContent">
                <div class="row">
                  <div class="col-3 text-right">
                    <img
                      :src="require('@/assets/img/check_white.png')"
                      alt="check_icon"
                      class="blaPackagesImg"
                    />
                  </div>
                  <div class="col-9 text-left blaPackagesBoxContentStrong">
                    Hozzáférés az összes filmes leckéhez
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-3 text-right">
                    <img
                      :src="require('@/assets/img/check_white.png')"
                      alt="lock_icon"
                      class="blaPackagesImg"
                    />
                  </div>
                  <div class="col-9 text-left blaPackagesBoxContentStrong">
                    Hozzáférés az összes előadás leckéihez
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-3 text-right">
                    <img
                      :src="require('@/assets/img/check_white.png')"
                      alt="lock_icon"
                      class="blaPackagesImg"
                    />
                  </div>
                  <div class="col-9 text-left blaPackagesBoxContentStrong">
                    Hozzáférés a havi témakör leckéihez
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-3 text-right">
                    <img
                      :src="require('@/assets/img/check_white.png')"
                      alt="lock_icon"
                      class="blaPackagesImg"
                    />
                  </div>
                  <div class="col-9 text-left blaPackagesBoxContentStrong">
                    Hozzáférés szókincsépítő leckékhez
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-3 text-right">
                    <img
                      :src="require('@/assets/img/check_white.png')"
                      alt="lock_icon"
                      class="blaPackagesImg"
                    />
                  </div>
                  <div class="col-9 text-left blaPackagesBoxContentStrong">
                    Hozzáférés a kiejtést fejlesztő leckékhez
                  </div>
                </div>
                <div class="row my-5 pt-5">
                  <div class="col-8 offset-2">
                    <div
                      @click="$router.push({ name: 'offer' })"
                      class="blaPackagesButton"
                    >
                      Váltás
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({}),
  methods: {
    goToPlaystore() {
      window.location.href =
        'https://play.google.com/store/apps/details?id=skillers.app';
    },
    goToAppleStore() {
      window.location.href =
        'https://apps.apple.com/us/app/skillers/id1479188539?ign-itsct=apps_box&ign-itscg=30200';
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
  computed: {},
  mounted: function () {
    this.scrollToTop();
  },
};
</script>
